"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _reactComponents = require("@ui-propulsion/react-components");
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var useStyles = (0, _reactComponents.makeStylesPropulsion)(function (theme) {
  var palette = theme.palette,
    typography = theme.typography,
    breakpoints = theme.breakpoints;
  var fontFamilyRegular = typography.fontFamilyRegular,
    pxToRem = typography.pxToRem;
  return {
    root: {
      margin: '0',
      fontFamily: fontFamilyRegular,
      color: palette.denim[500]
    },
    container: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center'
    },
    alert: _objectSpread(_objectSpread({}, typography.title1), {}, {
      margin: "".concat(pxToRem('16'), " auto 0 auto"),
      padding: "0 ".concat(pxToRem('16')),
      color: palette.denim[500]
    }),
    message: _objectSpread(_objectSpread({}, typography.body), {}, {
      margin: "".concat(pxToRem(24), " ").concat(pxToRem('40'), " ").concat(pxToRem(20), " ").concat(pxToRem('40')),
      padding: '0',
      textAlign: 'center',
      color: palette.sky[900]
    }),
    wrapper: {
      margin: pxToRem(24)
    },
    button: (0, _defineProperty2["default"])({
      width: "calc(100% - ".concat(pxToRem('48'), ")"),
      margin: "0 ".concat(pxToRem('24'))
    }, breakpoints.up('sm'), {
      margin: 'initial',
      width: 'initial'
    })
  };
}, {
  name: 'ErrorScreen'
});
exports.useStyles = useStyles;
